import { z } from "zod";
import { Solana } from "../solana/solana-base";
import { IsoDate } from "../util/data-types";
import { DbNftokenCollection } from "./NftokenSchema";
import { BaseTable, TableTimestamps } from "./schema-utils";
import { NftTypes } from "./SolanaTokenProgram";

export namespace GlowIdTypes {
  export const Network = Solana.Network.Mainnet;

  export const MetadataZ = z.object({
    name: z.string(),
    image: z.string(),
    bio: z.string().nullish(),
  });
  export type Metadata = z.infer<typeof MetadataZ>;

  export const DbDataZ = z.object({
    id_card_image_url: z.string().nullable(),
  });
  export type DbData = z.infer<typeof DbDataZ>;

  export const AccountZ = z.object({
    handle: z.string(),
    address: Solana.AddressZ,
    resolved: Solana.AddressZ,

    controller: Solana.AddressZ,
    delegate: Solana.AddressZ.nullable(),

    joined_at: z.string(),
    metadata_url: z.string(),
    twitter: z.string().nullable(),
    collection: z.string(),
    invited_by_handle: z.string().nullable(),
  });

  export type Account = z.infer<typeof AccountZ>;

  export const BasicInfoZ = AccountZ.pick({
    handle: true,
    resolved: true,
    twitter: true,
    joined_at: true,
    collection: true,
    invited_by_handle: true,
  })
    .merge(MetadataZ.partial())
    .merge(DbDataZ);

  export type BasicInfo = z.infer<typeof BasicInfoZ>;

  export type Dict = {
    glow_id_dict: {
      [address: Solana.Address]: BasicInfo;
    };
  };
}

export type DbGlowIdAccount = {
  handle: Solana.Address;

  address: Solana.Address;
  resolved: Solana.Address;

  controller: Solana.Address;
  delegate: Solana.Address | null;

  joined_at: IsoDate;

  metadata_url: string | null;

  twitter: string | null;
  invited_by_handle: string | null;

  collection: DbNftokenCollection["address"];

  id_card_image_url: string | null;
} & TableTimestamps;

export type DbGlowIdInvite = {
  created_by_address: Solana.Address;
  created_by_handle: DbGlowIdAccount["handle"];

  code: string;

  redeemed_for_nft_by: Solana.Address | null;
  redeemed_for_nft_at: IsoDate | null;

  redeemed_for_glow_id_by: Solana.Address | null;
  redeemed_for_glow_id_at: IsoDate | null;
  shared_at: IsoDate | null;

  nft_address: Solana.Address | null;
} & BaseTable;

export type DbGlowIdMetadata = {
  name: string;
  image: string;
  bio: string | null;
} & TableTimestamps;

export type DbGlowIdWhitelist = {
  handle: string;
  dollars: number | null;
  allowed: boolean;
} & TableTimestamps;

export type DbGlowIdGenesisNftInfo = {
  // Primary key. This is the NFT collection address.
  collection: Solana.Address;

  nft_name: string;
  nft_image: string;
  nft_traits: NftTypes.NftTrait[];
} & TableTimestamps;
